import type { CommandData } from '@festina/unitlink-general-types/unitlink'

import { UnitLinkAnnotationCommand } from '../../../areas/annotation/UnitLinkAnnotationCommand'
import type { CommandDataRecord } from '../types'
import { fundCommands } from './fundCommands'
import { portfolioCommands } from './portfolioCommands'

export const unitlinkCommands: CommandDataRecord<CommandData['_type']> = {
  AnnotationCommandData: UnitLinkAnnotationCommand,
  ...fundCommands,
  ...portfolioCommands,
}
